import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useContext } from 'react';
import { forwardRef } from '../../system/forwardRef.es.js';
import { ToggleButtonGroupContext } from './ToggleButtonGroup.es.js';
import { Styled } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var isValueSelected = function isValueSelected(value, reference) {
  if (value === "undefined" || reference === "undefined") {
    return false;
  }

  if (Array.isArray(reference)) {
    return reference.includes(value);
  }

  return value === reference;
};

var ToggleButton = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      value = _b.value,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      onClick = _b.onClick,
      onChange = _b.onChange,
      isSelected = _b.isSelected,
      props = __objRest(_b, ["children", "value", "size", "onClick", "onChange", "isSelected"]);

  var context = useContext(ToggleButtonGroupContext);

  var handleChange = function handleChange(event) {
    onClick == null ? void 0 : onClick(event, value);

    if (event.isDefaultPrevented()) {
      return;
    }

    onChange == null ? void 0 : onChange(event, value);
  };

  var isPressed = context.value ? isValueSelected(value, context.value) : isSelected;
  return (
    /* @__PURE__ */
    React.createElement(Styled.ToggleButton, __spreadValues({
      ref: ref,
      value: value,
      size: size,
      onClick: handleChange,
      variant: "ghost",
      "aria-pressed": isPressed ? true : void 0
    }, props), children)
  );
});
ToggleButton.displayName = "ToggleButton";
var ToggleIconButton = forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(ToggleButton, __spreadValues({
      p: 0,
      ref: ref
    }, props))
  );
});
ToggleIconButton.displayName = "ToggleIconButton";
export { ToggleButton, ToggleIconButton };